import React from 'react';
import PropTypes from 'prop-types';
import { slugify } from '../../utils/functions';
import { Container } from '../../components/Layout';

export const FAQanswers = ({ input }) => {
  const QuickLinks = input.items.map(({ faq_question, faq_answer }) => (
    <div
      key={slugify(faq_question)}
      id={faq_question ? slugify(faq_question) : null}
    >
      <h4>{faq_question}</h4>
      <span dangerouslySetInnerHTML={{ __html: faq_answer.html }} />
    </div>
  ));

  return (
    <Container
      restrict
      id={input.primary.section ? slugify(input.primary.section) : null}
    >
      <h2>{input.primary.section}</h2>
      {QuickLinks}
    </Container>
  );
};

export const FAQquestions = ({ input }) => {
  const QuickLinks = input.items.map(({ faq_question, faq_answer }) => (
    <h5 key={slugify(faq_question)}>
      <a href={faq_question ? '#' + slugify(faq_question) : null}>
        {faq_question}
      </a>
    </h5>
  ));

  return (
    <Container
      restrict
      margin={[3, 0, 1, 0]}
      id={input.primary.section ? slugify(input.primary.section) : null}
    >
      {QuickLinks}
    </Container>
  );
};

FAQanswers.propTypes = {
  input: PropTypes.object.isRequired,
};
FAQquestions.propTypes = {
  input: PropTypes.object.isRequired,
};
